"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFullWeeks = findFullWeeks;
exports.validateVacationWeeks = validateVacationWeeks;
const time_off_enums_1 = require("../constants/time-off.enums");
const attendance_correction_validation_1 = require("./attendance-correction.validation");
const DAYS_IN_WEEK = 7;
const utcDate = (day) => new Date(`${day}T00:00:00.000Z`);
function getWeekMonday(day) {
    const daysSinceMonday = (utcDate(day).getUTCDay() + 6) % DAYS_IN_WEEK;
    return (0, attendance_correction_validation_1.addDaysToDay)(day, -daysSinceMonday);
}
function formatDay(day, withMonth, withYear) {
    return new Intl.DateTimeFormat('es-MX', {
        timeZone: 'UTC',
        day: 'numeric',
        ...(withMonth ? { month: 'long' } : {}),
        ...(withYear ? { year: 'numeric' } : {}),
    }).format(utcDate(day));
}
/** «del 12 al 18 de octubre de 2026», or with the month or year on both sides when they differ */
function formatWeek(monday) {
    const sunday = (0, attendance_correction_validation_1.addDaysToDay)(monday, DAYS_IN_WEEK - 1);
    const sameYear = monday.slice(0, 4) === sunday.slice(0, 4);
    const sameMonth = monday.slice(0, 7) === sunday.slice(0, 7);
    return `del ${formatDay(monday, !sameMonth, !sameYear)} al ${formatDay(sunday, true, true)}`;
}
/**
 * Mondays (`YYYY-MM-DD`) of the Monday–Sunday weeks whose seven days are all in `days`.
 * Each entry is an instant and is read as its calendar day in Mexico.
 */
function findFullWeeks(days) {
    const daysByMonday = new Map();
    for (const value of days ?? []) {
        if (Number.isNaN(new Date(value).getTime()))
            continue;
        const day = (0, attendance_correction_validation_1.getMexicoDay)(value);
        const monday = getWeekMonday(day);
        const weekDays = daysByMonday.get(monday) ?? new Set();
        weekDays.add(day);
        daysByMonday.set(monday, weekDays);
    }
    return [...daysByMonday.entries()]
        .filter(([, weekDays]) => weekDays.size === DAYS_IN_WEEK)
        .map(([monday]) => monday)
        .sort();
}
/**
 * A vacation request may not hold the seven days of a Monday–Sunday week. The attendance report values each
 * vacation day at the habitual journey, so 7 × 8 h = 56 h against a 48 h week, and the 8 h left over are paid
 * as double overtime nobody worked (Javier, 2026-11-01). Other time-off types are not affected.
 */
function validateVacationWeeks(days, timeOffType) {
    if (timeOffType !== time_off_enums_1.TimeOffType.Vacation)
        return { isValid: true };
    const fullWeeks = findFullWeeks(days);
    if (fullWeeks.length === 0)
        return { isValid: true };
    const weeks = fullWeeks.map(formatWeek).join(', ');
    return {
        isValid: false,
        error: fullWeeks.length === 1
            ? `Las vacaciones no pueden cubrir una semana completa de lunes a domingo (${weeks}). ` +
                'Deja fuera al menos un día de esa semana.'
            : `Las vacaciones no pueden cubrir semanas completas de lunes a domingo (${weeks}). ` +
                'Deja fuera al menos un día de cada una.',
    };
}
